import React from "react";
import "./DocumentSkeleton.css";

const LINE_WIDTHS = [92, 100, 97, 100, 88, 100, 95, 64];

/**
 * Заглушка рабочей области той же геометрии, что шапка документа и лист:
 * пока идут запросы статуса/версии, страница не прыгает между экранами
 * загрузки, а документ проявляется на своём месте.
 */
interface DocumentSkeletonProps {
  /** Только лист — шапка документа уже на экране (например, грузится отчёт). */
  pageOnly?: boolean;
  /**
   * Место под свитчер документов. Нужно, пока грузится код страницы: свитчера
   * ещё нет, и без этого места skeleton съезжал вниз, когда тот появлялся.
   */
  withSwitcher?: boolean;
}

const DocumentSkeleton: React.FC<DocumentSkeletonProps> = ({
  pageOnly = false,
  withSwitcher = false,
}) => (
  <div className="doc-skeleton" aria-busy="true" aria-label="Загрузка документа">
    {withSwitcher && <div className="doc-skeleton__switcher" />}
    {!pageOnly && (
    <>
    <div className="doc-skeleton__header">
      <div className="doc-skeleton__title">
        <span className="doc-skeleton__block" style={{ width: 240, height: 18 }} />
        <span className="doc-skeleton__block" style={{ width: 110, height: 14 }} />
      </div>
      <span className="doc-skeleton__block doc-skeleton__modes" />
      <div className="doc-skeleton__actions">
        <span className="doc-skeleton__block" style={{ width: 88, height: 36 }} />
        <span className="doc-skeleton__block" style={{ width: 96, height: 36 }} />
        <span className="doc-skeleton__block" style={{ width: 100, height: 36 }} />
      </div>
    </div>
    <div className="doc-skeleton__toolbar">
      <span className="doc-skeleton__block" style={{ width: 240, height: 44 }} />
      <span className="doc-skeleton__block" style={{ flex: 1, height: 44 }} />
    </div>
    </>
    )}
    <div className="doc-skeleton__stage">
      <div className="doc-skeleton__page">
        <span className="doc-skeleton__block" style={{ width: "58%", height: 16, margin: "0 auto 28px" }} />
        {[0, 1].map((paragraph) => (
          <div className="doc-skeleton__paragraph" key={paragraph}>
            {LINE_WIDTHS.map((width, i) => (
              <span
                key={i}
                className="doc-skeleton__block doc-skeleton__line"
                style={{ width: `${width}%` }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default DocumentSkeleton;
